import SmartID from './SmartID';

export default SmartID;
